/** @jsx jsx */
import { jsx } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Pre = function Pre(_ref) {
  var children = _ref.children;
  return jsx("div", null, children);
};

if (typeof Pre !== 'undefined' && Pre && Pre === Object(Pre) && Object.isExtensible(Pre) && !Object.prototype.hasOwnProperty.call(Pre, '__filemeta')) {
  Object.defineProperty(Pre, '__filemeta', {
    configurable: true,
    value: {
      name: "Pre",
      filename: "node_modules/gatsby-theme-docz/src/components/Pre/index.js"
    }
  });
}